import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=3a564739&scoped=true"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a564739",
  null
  
)

export default component.exports